import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox } from '@mui/material';

import { SELECTED_DISPUTES } from '../../../modules/disputes/reducer';

const DisputeCheckbox = ({ disputeID, openDispute }) => {
  const dispatch = useDispatch();

  const isChecked = useSelector(store =>
    store.disputes.selectedDisputes.some(id => disputeID === id)
  );
  const user = useSelector(store => store.user);

  const isSuperUser = user.isSuperUser !== null;

  const disabled = !isSuperUser && !openDispute;

  return (
    <Checkbox
      disabled={disabled}
      checked={isChecked}
      onChange={event => {
        const isSelected = event.target.checked;
        dispatch({
          type: SELECTED_DISPUTES,
          payload: {
            disputeID,
            isSelected,
            isSuperUser
          }
        });
      }}
      size="small"
    />
  );
};

export default DisputeCheckbox;
